<template>
  <div class="next-page">
    <van-nav-bar
      :title="data.xuanfei_name || $t('details.title')"
      left-arrow
      class="custom-nav"
      @click-left="onClickLeft"
    />

    <div class="main-card">
      <div class="card-title">{{ $t('details.card_title') }}</div>

      <div class="basic-info">
        <div class="info-item">
          <span class="label">{{ $t('details.number') }}:</span>
          <span class="value">{{ data.xuanfei_name }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('details.area') }}:</span>
          <span class="value">{{ data.address }}</span>
        </div>
      </div>

      <div class="stats-section">
        <div class="stat-item">
          <div class="stat-number">{{ pageViews }}</div>
          <div class="stat-label">{{ $t('details.page_views') }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ data.dianzan || 0 }}</div>
          <div class="stat-label">{{ $t('details.likes') }}</div>
        </div>
      </div>

      <div class="image-section">
        <div class="image-container">
          <van-swipe :autoplay="3000" indicator-color="#c22988">
            <van-swipe-item
              v-for="(img, index) in data.img_url"
              :key="index"
            >
              <img
                :src="img || '/img/error.png'"
                alt=""
                class="swipe-img"
                @error="handleImageError"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64';
import { getCurrentLang, getLangFromLocale } from '../../common/lang';
import { getHomeRecommendDetailImages } from '../../common/homeRecommendImages';

export default {
  data() {
    return {
      data: {},
      currentIndex: 0,
      currentImage: '',
      isPraised: false,
    };
  },
  computed: {
    pageViews() {
      const raw = Number(
        this.data.liulan != null
          ? this.data.liulan
          : this.data.views != null
            ? this.data.views
            : this.data.click
      );
      let n = Number.isFinite(raw) && raw > 0
        ? raw
        : (Number(this.data.dianzan) || 0) * 27 + 9000;
      if (n >= 1000) {
        return (n / 1000).toFixed(2) + 'K';
      }
      return String(n);
    },
  },
  methods: {
    getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
        // 解码Base64数据
        if (typeof res.data === 'string') {
          try {
            this.data = JSON.parse(Base64.decode(res.data));
          } catch (e) {
            console.error('Base64解码失败:', e);
            this.data = res.data;
          }
        } else {
          this.data = res.data;
        }

        // 根据当前语言选择对应的标签
        if (this.data.flag) {
          const parts = this.data.flag.split('|');
          const langMap = {
            'zh': 0,
            'en': 1,
            'ja': 2,
            'de': 1, // 使用英语作为德语的后备
            'kr': 1, // 使用英语作为韩语的后备
            'mn': 0, // 蒙古语使用中文作为后备
            'es': 1  // 西班牙语使用英语作为后备
          };
          const locale = (this.$i18n && this.$i18n.locale) || null;
          const currentLang = locale ? getLangFromLocale(locale) : getCurrentLang();
          const langIndex = langMap[currentLang] || 0;
          this.data.flag = parts[langIndex] || parts[0] || '';
          this.data.flagArray = this.data.flag ? this.data.flag.split('，') : [];
        } else {
          this.data.flagArray = [];
        }

        // 确保 img_url 是数组
        if (!this.data.img_url) {
          this.data.img_url = [];
        } else if (!Array.isArray(this.data.img_url)) {
          // 如果是字符串，尝试转换为数组
          if (typeof this.data.img_url === 'string') {
            try {
              this.data.img_url = JSON.parse(this.data.img_url);
            } catch (e) {
              // 如果解析失败，当作单个图片处理
              this.data.img_url = [this.data.img_url];
            }
          } else {
            this.data.img_url = [this.data.img_url];
          }
        }

        this.applyDetailImagesFallback();
			}).then(() => {
        // 默认选中第一张照片
        this.currentIndex = 0;
        if (this.data.img_url && this.data.img_url.length > 0 && this.data.img_url[0]) {
          this.currentImage = this.data.img_url[0];
        } else {
          this.currentImage = '/img/error.png';
        }

        // 初始化点赞状态和数量
        if (typeof this.data.dianzan === 'undefined' || this.data.dianzan === null) {
          this.data.dianzan = 0;
        }
        this.isPraised = false;
        
        // 使用 $nextTick 确保 DOM 更新
        this.$nextTick(() => {
          if (this.currentImage && this.currentImage !== '/img/error.png') {
            console.log('当前显示图片:', this.currentImage);
          }
        });
      });
    },

    getListIndexForMember(memberId) {
      const q = this.$route.query.idx;
      if (q != null && q !== '') {
        const n = Number(q);
        return Promise.resolve(Number.isFinite(n) && n >= 0 ? n : 0);
      }
      return this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: 1, page: 1 },
      })
        .then((res) => {
          const list = (res && res.data) || [];
          const i = list.findIndex((item) => String(item.id) === String(memberId));
          return i >= 0 ? i : 0;
        })
        .catch(() => 0);
    },

    applyDetailImagesFallback() {
      const hasApiImages =
        Array.isArray(this.data.img_url) &&
        this.data.img_url.length > 0 &&
        this.data.img_url.some((u) => u && u !== '/img/error.png');
      if (hasApiImages) {
        return Promise.resolve();
      }
      const memberId = this.$route.query.id;
      return this.getListIndexForMember(memberId).then((listIndex) => {
        this.data.img_url = getHomeRecommendDetailImages(listIndex);
      });
    },

    onClickImg(index) {
      if (this.data.img_url && this.data.img_url[index]) {
        this.currentIndex = index;
        this.currentImage = this.data.img_url[index];
      }
    },
    handleImageError(event) {
      event.target.src = '/img/error.png';
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    clickPraise() {
      if (this.isPraised) {
        // 如果已经点赞，则减1
        if (this.data.dianzan > 0) {
          this.data.dianzan--;
        }
        this.isPraised = false;
      } else {
        // 如果未点赞，则加1
        this.data.dianzan++;
        this.isPraised = true;
      }
    },
    getStarValue() {
      // 根据 data.number 返回星星数量，默认5颗星
      const rating = this.data.number;
      if (rating === null || rating === undefined || rating === 0) {
        return 5; // 默认5颗星
      }
      return Math.max(1, Math.min(5, Math.round(rating)));
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.getxuanfeidata();
  },
};
</script>

<style scoped lang="less">
.next-page {
  min-height: 100vh;
  background: #f2f2f5;
  padding-bottom: 30px;
}

.custom-nav {
  background: #fff !important;
}

::v-deep .custom-nav .van-nav-bar__title {
  color: #333;
  font-weight: 500;
}

::v-deep .custom-nav .van-icon {
  color: #333 !important;
}

.main-card {
  margin: 16px;
  padding: 22px 18px;
  background: #fff;
  border: 1px solid #7c6cf0;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(124, 108, 240, 0.08);
}

.card-title {
  text-align: center;
  color: #6b5ce7;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 24px;
}

.basic-info {
  margin-bottom: 22px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 14px;
  font-size: 24px;
  line-height: 1.4;
}

.info-item .label {
  color: #333;
  font-weight: 600;
  margin-right: 8px;
}

.info-item .value {
  color: #8a6d3b;
}

.stats-section {
  display: flex;
  margin-bottom: 24px;
}

.stat-item {
  flex: 1;
  text-align: center;
}

.stat-number {
  color: #6b5ce7;
  font-size: 46px;
  font-weight: 700;
  margin-bottom: 8px;
}

.stat-label {
  color: #8a6d3b;
  font-size: 20px;
}

.image-section {
  margin-top: 8px;
}

.image-container {
  border-radius: 12px;
  overflow: hidden;
}

.swipe-img {
  width: 100%;
  height: 680px;
  object-fit: cover;
  display: block;
}

::v-deep .van-swipe__indicator--active {
  background-color: #c22988 !important;
}
</style>
